<div class="container-fluid">
  <div class="card">

    <!-- Header -->
    <div class="card-header nocollapse">
      Manage Service Line
    </div>

    <!-- Status message -->
    <div *ngIf="successOrFailureMessage !== ''"
         class="card-header nocollapse bg-info col-md-12 msg-container">
      <i class="fa fa-info-circle fa-lg mt-1" style="color: #326295;"></i>
      <b>{{ successOrFailureMessage }}</b>
    </div>

    <!-- Action buttons -->
    <div class="page-attributes p-1" style="margin-left:10px; margin-top:0;">
      <button class="btn btn-sm btn-primary btn-action"
              (click)="openCreateServiceLineModal()">
        <i class="fa fa-plus"></i> Create New Service Line
      </button>
      <button class="btn btn-sm btn-primary btn-action"
              (click)="openExternalLinkModal()">
        <i class="fa fa-download"></i> External Link
      </button>
    </div>

    <!-- IsgGridComponent (same as user/company) -->
    <isg-grid [rowData]="serviceLineList"
              [columnDefs]="columnDefs"
              [defaultColDef]="defaultColDef"
              [config]="gridConfig"
              (gridReady)="onGridReady($event)">
    </isg-grid>

  </div>
</div>

<!-- ── Create / Edit Service Line Modal ─────────────────────── -->
<ng-template #serviceLineModal let-modal>
  <div class="modal-header">
    <h5 class="modal-title">
      {{ currentServiceLineId > 0 ? 'Edit' : 'Create New' }} Service Line
    </h5>
    <button type="button" class="btn-close" aria-label="Close"
            (click)="modal.dismiss(); onClose()"></button>
  </div>
  <div class="modal-body">
    <form [formGroup]="serviceLineForm">

      <!-- Service Line Name -->
      <div class="row mb-2">
        <label class="col-md-4 col-form-label">
          Service Line Name <span class="text-danger">*</span>
        </label>
        <div class="col-md-8">
          <input type="text"
                 maxlength="100"
                 formControlName="serviceLineName"
                 class="form-control form-control-sm" />
          <small class="text-danger"
                 *ngIf="serviceLineForm.get('serviceLineName')?.hasError('servicelineExists')">
            Service line already exists.
          </small>
          <small class="text-danger"
                 *ngIf="serviceLineForm.get('serviceLineName')?.hasError('required') && serviceLineForm.get('serviceLineName')?.touched">
            Service line name is required.
          </small>
        </div>
      </div>

      <!-- Description -->
      <div class="row mb-2">
        <label class="col-md-4 col-form-label">Description</label>
        <div class="col-md-8">
          <textarea maxlength="200"
                    formControlName="serviceLineDescription"
                    class="form-control form-control-sm"
                    rows="3"></textarea>
        </div>
      </div>

      <!-- Is Active -->
      <div class="row mb-2">
        <div class="col-md-4"></div>
        <div class="col-md-8 d-flex align-items-center gap-2">
          <input type="checkbox" id="isActive" formControlName="isActive"
                 class="form-check-input" />
          <label for="isActive" class="form-check-label">Is Active</label>
        </div>
      </div>

      <!-- Show Analysis Report -->
      <div class="row mb-2">
        <div class="col-md-4"></div>
        <div class="col-md-8 d-flex align-items-center gap-2">
          <input type="checkbox" id="showAnalysisReport"
                 formControlName="showAnalysisReport" class="form-check-input" />
          <label for="showAnalysisReport" class="form-check-label">Show Analysis Report</label>
        </div>
      </div>

      <!-- Show Overview Report -->
      <div class="row mb-2">
        <div class="col-md-4"></div>
        <div class="col-md-8 d-flex align-items-center gap-2">
          <input type="checkbox" id="showOverviewReport"
                 formControlName="showOverviewReport" class="form-check-input" />
          <label for="showOverviewReport" class="form-check-label">Show Overview Report</label>
        </div>
      </div>

      <!-- Show Grouping and Communication Icon -->
      <div class="row mb-2">
        <div class="col-md-4"></div>
        <div class="col-md-8 d-flex align-items-center gap-2">
          <input type="checkbox" id="showGroupingAndCommunicationIcon"
                 formControlName="showGroupingAndCommunicationIcon" class="form-check-input" />
          <label for="showGroupingAndCommunicationIcon" class="form-check-label">
            Show Grouping And Communication Icon
          </label>
        </div>
      </div>

    </form>
  </div>
  <div class="modal-footer">
    <button type="button" class="btn btn-secondary btn-modal"
            (click)="modal.dismiss(); onClose()">
      <i class="fa fa-times"></i> Close
    </button>
    <button type="button" class="btn btn-primary btn-modal"
            [disabled]="serviceLineForm.invalid"
            (click)="modal.close(); saveServiceLine()">
      <i class="fa fa-save"></i> Save
    </button>
  </div>
</ng-template>

<!-- ── Delete Confirmation Modal ─────────────────────────────── -->
<ng-template #deleteServiceLineModal let-modal>
  <div class="modal-header">
    <h5 class="modal-title">Delete Confirmation</h5>
    <button type="button" class="btn-close" aria-label="Close"
            (click)="modal.dismiss()"></button>
  </div>
  <div class="modal-body">
    <p>Are you sure you want to delete this Service Line?</p>
    <p class="text-danger">
      <strong>Note:</strong><br />
      The Service Line is already mapped to Survey(s) and Service Provider(s) and deletion
      will remove all those mappings. User responses for this Service Line will also be deleted.
    </p>
  </div>
  <div class="modal-footer">
    <button type="button" class="btn btn-secondary btn-modal"
            (click)="modal.dismiss()">
      <i class="fa fa-times"></i> Close
    </button>
    <button type="button" class="btn btn-danger btn-modal"
            (click)="modal.close(); deleteServiceLine()">
      <i class="fa fa-trash"></i> Delete
    </button>
  </div>
</ng-template>

<!-- ── External Link Modal ────────────────────────────────────── -->
<ng-template #externalLinkModal let-modal>
  <div class="modal-header">
    <h5 class="modal-title">External Link</h5>
    <button type="button" class="btn-close" aria-label="Close"
            (click)="modal.dismiss(); closeExternalLinkForm()"></button>
  </div>
  <div class="modal-body">
    <form [formGroup]="externalLinkForm">

      <!-- Link Name -->
      <div class="mb-2">
        <label class="form-label">Link Name <span class="text-danger">*</span></label>
        <select class="form-select form-select-sm"
                formControlName="linkId"
                (change)="getMappedLink()">
          <option *ngFor="let link of linkList" [ngValue]="link?.linkId">
            {{ link.linkName }}
          </option>
        </select>
      </div>

      <!-- Service Line -->
      <div class="mb-2">
        <label class="form-label">Service Line <span class="text-danger">*</span></label>
        <select class="form-select form-select-sm"
                formControlName="serviceLineId"
                (change)="getMappedServiceProvider()">
          <option *ngFor="let sl of serviceLineList" [ngValue]="sl?.serviceLineId">
            {{ sl.serviceLineName }}
          </option>
        </select>
      </div>

      <!-- Company Name -->
      <div class="mb-2">
        <label class="form-label">Company Name <span class="text-danger">*</span></label>
        <select class="form-select form-select-sm"
                formControlName="companyId"
                (change)="getClientAdminList()">
          <option *ngFor="let company of serviceLineServiceProviderMapList"
                  [ngValue]="company?.companyId">
            {{ company.companyName }}
          </option>
        </select>
      </div>

      <!-- Survey Name -->
      <div class="mb-2">
        <label class="form-label">Survey Name <span class="text-danger">*</span></label>
        <select class="form-select form-select-sm" formControlName="surveyId">
          <option *ngFor="let survey of serviceLineSurveyMapList"
                  [ngValue]="survey?.surveyId">
            {{ survey.surveyName }}
          </option>
        </select>
      </div>

      <!-- Client Admin Name -->
      <div class="mb-2">
        <label class="form-label">Client Admin Name <span class="text-danger">*</span></label>
        <select class="form-select form-select-sm" formControlName="clientAdminId">
          <option *ngFor="let admin of clientAdminList"
                  [ngValue]="admin?.clientAdminId">
            {{ admin.clientAdminName }}
          </option>
        </select>
      </div>

    </form>
  </div>
  <div class="modal-footer">
    <button type="button" class="btn btn-secondary btn-modal"
            (click)="modal.dismiss(); closeExternalLinkForm()">
      <i class="fa fa-times"></i> Close
    </button>
    <button type="button" class="btn btn-primary btn-modal"
            [disabled]="externalLinkForm.invalid"
            (click)="modal.close(); saveLinkMapping()">
      <i class="fa fa-save"></i> Save
    </button>
  </div>
</ng-template>
